import { inject, injectable } from "inversify";
import { ICPLClientPortalCaseTypesClient, IntSelectModel } from "./api/cplapi/CPLAPI";
import { SERVICE_TYPES } from "setup/dependency/ServiceTypes";

export interface IClientPortalCaseTypesService {
  getCaseTypeSelectModels(): Promise<IntSelectModel[]>;
}

@injectable()
export class ClientPortalCaseTypesService implements IClientPortalCaseTypesService {
  @inject(SERVICE_TYPES.CPLClientPortalCaseTypesClient)
  cplClientPortalCaseTypesClient!: ICPLClientPortalCaseTypesClient;

  async getCaseTypeSelectModels(): Promise<IntSelectModel[]> {
    return this.cplClientPortalCaseTypesClient.getCaseTypeSelectModels();
  }
}
